import { Injectable, inject } from '@angular/core';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class PlatformService {
  private platform = inject(Platform);

  // Ionic `mobile` is any-pointer:coarse, unlike CapacitorService.mobile (native only).
  get mobile() {
    return this.platform.is('mobile');
  }

  ready() {
    return this.platform.ready();
  }
}
